/*
*###############################################################################
*Module Name                   : InvoiceMaster.js                              #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Malisha Fernando                              #
*Date                          : Friday, June 03th 2022                        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import InvoiceMasterContent from './InvoiceMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import DPPrintOption from 'framework/widgets/DPPrintOptions'
import InvoiceMasterPayment from './InvoiceMasterPayment'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from 'react'
import { useHistory } from 'react-router-dom';
import { DeleteInvoiceDetails, InvoiceDetailsGetData, SaveInvoiceDetails } from './InvoiceController'
import { set } from 'lodash'

const paymentObj = [
    {
        id: 1,
        Paycode: "",
        PayCodeDisable: false,
        Paydesc: "",
        PayDetcode: "",
        PayDetcodeDesable: true,
        PayDetName: "",
        PayAmount: 0,
        PayAmountDisable: true,
        AccountCode: "",
        AccountCodeDisable: true,
        ExpDate: "",
        ExpDateDisable: true,
        PayDetFormat: "",
        IsEditable: true
    }
]

const InvoiceMaster = (props) => {
    let history = useHistory();

    //*** User input related states */
    const [strInvoiceCode, SetCode] = useState("");// Set Invoice Code 
    const [invoiceDOB, setinvoiceDOB] = useState('');// Set Date Value 
    const [strCusCode, SetCusCode] = useState("");// Set Customer Code
    const [strCusName, setCusName] = useState("");// Set Customer Name
    const [strLocCode, SetLocation] = useState("");// Set Location Code
    const [strLocDesc, setLocDesc] = useState("");// Set Location Name  
    const [strCashier, SetCashier] = useState("");// Set Cashier ID
    const [strCashierName, setCashierName] = useState("");// Set Cashier Name
    const [strPosId, SetPosId] = useState("");// Set PosId
    const [strAmount, SetAmount] = useState("");// Set Invoice Amount 
    const [arRow, setarRow] = useState([{ id: 1 }])
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    const [paidList, setpaidList] = useState([])
    const [actualPaumentList, setActualPaymentList] = useState([])
    const [strRemarks, SetRemarks] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")

    const [paymentList, setPaymentList] = useState([{
        id: 1,
        Paycode: "",
        PayCodeDisable: false,
        Paydesc: "",
        PayDetcode: "",
        PayDetcodeDesable: true,
        PayDetName: "",
        PayAmount: 0,
        PayAmountDisable: true,
        AccountCode: "",
        AccountCodeDisable: true,
        ExpDate: "",
        ExpDateDisable: true,
        PayDetFormat: "",
        IsEditable: true
    }])
    const [paidAmount, setPaidAmount] = useState(0)
    const [netAmount, setNetAmount] = useState(0)
    const [disable, setDisable] = useState(false)

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, cashbokDate, addtoFavourite
    } = useContext(Context);
    //import from contexts

    var time = process.env.REACT_APP_ALERTTIMEOUT
    //**Get File Details */

    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.strHelpUrl)
                menuTAG = result.data.strMenuTag

                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {

                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {

                                setAutoCode(responseData.data)
                            }
                        } else {
                            setNullCode(true)
                        }
                    })

            }).catch(error =>
                console.log('error', error)
            );

    }, [strInvoiceCode])


    // Update the detailRows array with calculated values
    const updateCalculatedRows = async () => {

        const updatedRows = detailRows.map((row) => calculateRow(row));
        setDetailRows(updatedRows);


        // Calculate total amount and total discount
        const { totalAmount, totalDiscount } = updatedRows.reduce(
            (totals, row) => {
                totals.totalAmount += parseFloat(row.Amount);
                totals.totalDiscount += (parseFloat(row.DiscAmt || 0) + ((parseFloat(parseFloat(row.DiscPer).toFixed(2) || 0) / 100) * (parseFloat(row.Selling) * parseFloat(row.count))));
                return totals;
            },
            { totalAmount: 0, totalDiscount: 0 }
        );

        const { totalDiscountExcluded } = updatedRows.reduce((totals, row) => {

            if (row.DiscPer === 0 && row.DiscAmt === 0) {
                totals.totalDiscountExcluded += (parseFloat(discountPercentage || 0) / 100) * (parseFloat(row.Selling) * parseFloat(row.count));
            }

            return totals;
        },
            { totalDiscountExcluded: 0 }
        );


        setDiscountAmount(totalDiscount + totalDiscountExcluded)
        setGrossAmount(totalAmount)
        setNetAmount(totalAmount - totalDiscountExcluded)


    };


    async function CalculatePaidAmount(calculatedList = []) {

        //calculate paid amount
        var paidAmount = 0

        if (calculatedList.length > 0) {
            calculatedList.map((item) => {

                if (item.Paycode != "") {
                    paidAmount = paidAmount + parseFloat(item.PayAmount)
                }

            })
        } else {
            paymentList.map((item) => {

                if (item.Paycode != "") {
                    paidAmount = paidAmount + parseFloat(item.PayAmount)
                }

            })
        }



        setPaidAmount(paidAmount)

    }


    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])

    // //*** Get and Set values when user search code */
    // async function getData(searchData) {

    //     if (searchData == "") return

    //     SetLoadingAlert(true)
    //     SetLoadingAlerttitle("Fetching...")

    //     const result = await InvoiceDetailsGetData(searchData);

    //     SetLoadingAlert(false)

    //     if (result.success == true) {
    //         setinvoiceDOB(result.data.invoiceDOB.slice(0, 10))
    //         SetCusCode(result.data.strCusCode)
    //         setCusName(result.data.strCusName)
    //         SetLocation(result.data.strLocCode)
    //         setLocDesc(result.data.strLocDesc)
    //         SetCashier(result.data.strCashierId)
    //         setCashierName(result.data.strCashierName)
    //         SetPosId(result.data.strPosId)
    //         SetAmount(parseFloat(result.data.strInvoiceAmount).toFixed(2))
    //         setActualPaymentList(result.data.invDetails)
    //         setDisable(true)
    //         setNetAmount(parseFloat(result.data.strInvoiceAmount))

    //         let paymentCodeList = []
    //         result.data.invDetails.map((item, index) => {

    //             paymentCodeList.push({
    //                 id: index + 1,
    //                 Paycode: item.ph_code,
    //                 PayCodeDisable: true,
    //                 Paydesc: item.ph_desc,
    //                 PayDetcode: item.pd_code,
    //                 PayDetcodeDesable: true,
    //                 PayDetName: item.pd_desc,
    //                 PayAmount: item.paid_amount,
    //                 PayAmountDisable: true,
    //                 AccountCode: item.ref_no,
    //                 AccountCodeDisable: true,
    //                 ExpDate: item.date,
    //                 ExpDateDisable: true,
    //                 PayDetFormat: item.rate,
    //                 IsEditable: item.isEditable
    //             })
    //         })
    //         setPaymentList(paymentCodeList)
    //         CalculatePaidAmount(paymentCodeList);


    //         setarRow([])
    //         setTimeout(() => {
    //             setarRow([{ id: 1 }])
    //         }, 1)
    //         setCrEnable(true)
    //         setDisabled(true)
    //         setDisabledCode(true)
    //         setSaveEnable(false)
    //         SetAddNew(false)
    //         SetEditEnable(true)
    //         SetDeleteEnable(true)


    //     } else if (result.success == false) {
    //         if (nullCode == false) {
    //             setDisabledCode(false)
    //             displayAlertMessage('danger', "Invoice Not Found !")
    //             SetCode("")
    //         }
    //     }

    // }


    //*** Get and Set values when user search code */
    async function getData(searchData) {

        if (searchData == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await InvoiceDetailsGetData(searchData, LocationCode);

        SetLoadingAlert(false)

        if (result.success == true) {

            // if (result.data.invoiceDOB.slice(0, 10) > cashbokDate) {

                setinvoiceDOB(result.data.invoiceDOB.slice(0, 10))
                SetCusCode(result.data.strCusCode)
                setCusName(result.data.strCusName)
                SetLocation(result.data.strLocCode)
                setLocDesc(result.data.strLocDesc)
                SetCashier(result.data.strCashierId)
                setCashierName(result.data.strCashierName)
                SetPosId(result.data.strPosId)
                SetAmount(parseFloat(result.data.strInvoiceAmount).toFixed(2))
                setActualPaymentList(result.data.invDetails)
                setDisable(true)
                setNetAmount(parseFloat(result.data.strInvoiceAmount))

                let paymentCodeList = []
                result.data.invDetails.map((item, index) => {

                    paymentCodeList.push({
                        id: index + 1,
                        Paycode: item.ph_code,
                        PayCodeDisable: true,
                        Paydesc: item.ph_desc,
                        PayDetcode: item.pd_code,
                        PayDetcodeDesable: true,
                        PayDetName: item.pd_desc,
                        PayAmount: item.paid_amount,
                        PayAmountDisable: true,
                        AccountCode: item.ref_no,
                        AccountCodeDisable: true,
                        ExpDate: item.date,
                        ExpDateDisable: true,
                        PayDetFormat: item.rate,
                        IsEditable: item.isEditable
                    })
                })
                setPaymentList(paymentCodeList)
                CalculatePaidAmount(paymentCodeList);


                setarRow([])
                setTimeout(() => {
                    setarRow([{ id: 1 }])
                }, 1)
                setCrEnable(true)
                setDisabled(true)
                setDisabledCode(true)
                setSaveEnable(false)
                SetAddNew(false)
                SetEditEnable(true)
                SetDeleteEnable(true)

            // } else {

            //     displayAlertMessage('danger', "Invoice Date is Earlier than Cashbook Date");
            // }


        } else if (result.success == false) {
            setDisabledCode(false)
            displayAlertMessage('danger', "Invoice Not Found !")
            SetCode("")
        }

    }


    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //*** End useEffect */

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }


    //save button function
    const handlesave = async () => {

        let InvoiceMasterPayment = []

        paymentList.map((item, index) => {

            if (item.Paycode != "" && item.PayAmount > 0) {
                InvoiceMasterPayment.push(InvoiceMasterPaymentBuilder(item, index))
            }
        })

        if (InvoiceMasterPayment.length == 0) {
            displayAlertMessage('danger', "Please Add Payments")
            return;
        }

        if (paidAmount == 0) {
            displayAlertMessage('danger', "Please Add Payments")
            return;
        }

        if (parseFloat(paidAmount) != parseFloat(netAmount)) {
            displayAlertMessage('danger', "Paid Amount and Net Amount Not Equal")
            return;
        }


        const VenderDesignation = {
            "strInvoiceNo": strInvoiceCode,
            "INVDETAILS": InvoiceMasterPayment,
            "menuCode": menuCode,
            "loggedCompany": LogCompanyCode,
            "loggedLocation": LocationCode,
            "createdBy": LogUserType,
            "invLocation": strLocCode,
            "reason": Reason,

        }

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        //*** save/update records */
        const result = await SaveInvoiceDetails(VenderDesignation);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()
        } else {
            displayAlertMessage("danger", result.data)
        }
    }

    //***save/update end */


    const InvoiceMasterPaymentBuilder = (row) => {
        let date = new Date().toISOString();
        return {

            ph_code: row.Paycode,
            pd_code: row.PayDetcode,
            ref_no: row.AccountCode,
            amount: parseFloat(netAmount),
            paid_amount: parseFloat(row.PayAmount),
            canceled: 0,
            rate: parseFloat(1),
            // date: row.ExpDate == "" ? "1900-01-01" : row.ExpDate,
            date: row.ExpDate == null ? "1900-01-01" : row.ExpDate,
            date_time: date.toString().slice(0, 10),

        }
    }

    //*** Get user selected row details */
    const GetSelectRow = (row, isSelect, rowIndex, e) => {
        SetCode(row.code);
        getData(row.code)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrBy(row.crby)
        setMdBy(row.mdby)
        setCrDate(row.crdate)
        setMdDate(row.mddate);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
        setDisable(false)
    }

    //new button function
    const handleNew = e => {
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        setinvoiceDOB("")
        SetCusCode("")
        setCusName("")
        SetRemarks("")
        //setPaidAmount(0)
        SetLocation("")
        setLocDesc("")
        SetCashier("")
        setCashierName("")
        SetPosId("")
        SetAmount("")
        setActualPaymentList([])
        setarRow([])
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setReason("Created")
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setpaidList([])
        setExcelItems([])
        setarRow([])
        setTimeout(() => {
            setExcelItems([])
            setarRow([{ id: 1 }])
        }, 1)
        setPaymentList([{
            id: 1,
            Paycode: "",
            PayCodeDisable: false,
            Paydesc: "",
            PayDetcode: "",
            PayDetcodeDesable: true,
            PayDetName: "",
            PayAmount: 0,
            PayAmountDisable: true,
            AccountCode: "",
            AccountCodeDisable: true,
            ExpDate: "",
            ExpDateDisable: true,
            PayDetFormat: ""
        }])
        setPaidAmount(0)
        setNetAmount(0)
    }

    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strInvoiceCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteInvoiceDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {
            displayAlertMessage("danger", result.data)
        }
    }
    //*********Delete button function end */


    // print Function
    async function handlePrint(option) {
        const authToken = localStorage.getItem("authToken")
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/Invoice/report/${LogUserType}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            })
    }
    //**Permission Check */
    const permission = (operation) => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    //**Remove Payment Row */
    function handlePayRemoveRow(id, code, desc) {

        var PaymentDet = []
        var tbl = document.getElementById("PaymentDet")

        if (tbl != null) {
            let rowCount = tbl.tBodies[0].rows.length
            for (let i = 0; i < rowCount; i++) {
                var txtPaycode = document.getElementById("txtPaycode" + i).value
                var txtPaydesc = document.getElementById("txtPaydesc" + i).value
                var txtPaydetCode = document.getElementById("txtPaydetCode" + i).value
                var txtPayDetName = document.getElementById("txtPayDetdesc" + i).value
                var txtAccountCode = document.getElementById("txtAccountCode" + i).value
                var txtExpDate = document.getElementById("txtExpDate" + i).value
                var txtPayAmount = document.getElementById("txtPayAmount" + i).value

                PaymentDet = PaymentDet.concat
                    ({
                        "id": i + 1,             //assign unique id for each object
                        "Paycode": txtPaycode,
                        "Paydesc": txtPaydesc,
                        "PayDetcode": txtPaydetCode,
                        "PayDetName": txtPayDetName,
                        "AccountCode": txtAccountCode,
                        "PayAmount": txtPayAmount,
                        "ExpDate": txtExpDate,
                    }

                    )
            }
            var newarray = []  // newarray for crear the table
            var finalarray = [] //final array to store fillered table data with new id
            var modifiedRows = [...PaymentDet]

            if (id !== 0) {
                modifiedRows = modifiedRows.filter(x => x["id"] !== id) // filtering table data and asign them to a new variable
                //modify table giving new id order
                modifiedRows.map((obj, index) => {
                    finalarray = finalarray.concat({
                        "id": index + 1,
                        "Paycode": obj["Paycode"],
                        "Paydesc": obj["Paydesc"],
                        "PayDetcode": obj["PayDetcode"],
                        "PayDetName": obj["PayDetName"],
                        "PayAmount": obj["PayAmount"],
                        "AccountCode": obj["AccountCode"],
                        "ExpDate": obj["ExpDate"],
                    })
                })

                setarRow(newarray)

                if (finalarray.length != 0) { //if table not empty set new object arry
                    setTimeout(() => {
                        setarRow(finalarray)
                    }, 1)
                } else {

                    setTimeout(() => {  // if table empty set empty row
                        setarRow([{ id: 1 }])
                    }, 1)
                }
            }
        }
    }


    const AddPayRow = () => {

        const modifiedRows = [...arRow]
        modifiedRows.push({ id: modifiedRows.length + 1 })
        setarRow(modifiedRows)

    }


    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)

                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)

                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={false}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={false}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <InvoiceMasterContent
                                            RemarkValue={strRemarks}
                                            RemarkOnChange={e => {
                                                let valCode = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetRemarks(valCode)
                                            }}

                                            GetSelectRow={GetSelectRow}
                                            Invoice_Value={strInvoiceCode}
                                            Invoice_onChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    20,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}

                                            DateValue={invoiceDOB}
                                            DateonChange={(e) => {
                                                setinvoiceDOB(e.target.value)
                                            }}

                                            CusValue={strCusCode}
                                            CusOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetCusCode(val2)
                                            }}
                                            CusName={strCusName}
                                            LocationValue={strLocCode}
                                            LocationOnChange={e => {
                                                let val3 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetLocation(val3)
                                            }}
                                            LocDesc={strLocDesc}
                                            CashierValue={strCashier}
                                            CashierOnChange={e => {
                                                let val4 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetCashier(val4)
                                            }}
                                            CashierName={strCashierName}
                                            PosValue={strPosId}
                                            PosOnChange={e => {
                                                let val5 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetPosId(val5)
                                            }}
                                            InAmtValue={strAmount}
                                            InAmtOnChange={e => {
                                                let val6 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetAmount(val6)
                                            }}
                                            DataRow={arRow}
                                            //RemoveRow={handleRemoveRow}
                                            // AddRow={handleAddRowNested}
                                            menuCode={menuCode}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            Invoice_OnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                // AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            RemovePayRow={handlePayRemoveRow}
                                            AddPayRow={AddPayRow}
                                            paidList={paidList}
                                            actualPaumentList={actualPaumentList}
                                        />
                                    </Row>
                                    <Row>
                                        <InvoiceMasterPayment
                                            setPaymentList={setPaymentList}
                                            paymentList={paymentList}
                                            disable={disable}
                                            menuCode={menuCode}
                                            CalculatePaidAmount={CalculatePaidAmount}
                                            paidAmount={paidAmount}
                                            netAmount={netAmount}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default InvoiceMaster